<template>
  <div>
    <nav-bar-main></nav-bar-main>
    <!-- <nav-bar-bom></nav-bar-bom> -->

    <b-alert
      v-if="plantDetails != null && plantDetails.plant_type == 'basic'"
      show
      variant="warning"
      style="display:inline-block;width:100%"
    >
      <banner-pro />
    </b-alert>

    <b-alert
      v-if="plantDetails != null && $store.getters.isProExpired"
      show
      variant="warning"
      style="display:inline-block;width:100%"
    >
      <banner-pro-expired />
    </b-alert>

    <!-- <div v-if="error != null" class="alert alert-danger" role="alert">
      {{ $t(error) }}
    </div> -->
    <ErrorBanner />
    <Loader />
    <div
      v-if="$store.state.loading == false"
      class="reportImpiantoMainContent animated fadeIn container-fluid"
    >
      <!-- TABELLA BOM -->
      <b-row class="mt-3">
        <b-col cols="12">
          <b-card class="home-widget text-widget radius-card ml-4 mr-4 mb-4">
            <template v-slot:header style="background-color:white">
              <div class="pt-2">
                <span class="mr-2">{{ $t("bom.title_bom") }}</span>
                <span v-if="filtriAttivi" class="mr-2">{{ $t("bom.filterOn") }}</span>
                <br />
                <b-button v-if="tableBomComputed.length > 0" class="noborder-button download" @click="createPDF_Bom">
                  <i class="fas fa fa-1x fa-download mr-2"></i>Download
                </b-button>
              </div>
            </template>
            <v-client-table
              v-if="tableBomComputed.length > 0"
              :columns="columnsBom"
              :data="tableBomComputed"
              :options="optionsBom"
              :theme="theme"
              id="dataTable"
              ref="table"
              class="borderless text-primary widget-table"
            >
              <!-- in ogni riga un dispositivo -->
              <div slot="prod_image" slot-scope="props" id="id_image">
                <div v-if="(props.row.prod_image != '') && (props.row.prod_image != null)">
                  <img :src="props.row.prod_image.includes('|') ? pathDeviceImages + props.row.prod_image.split('|')[0] : pathDeviceImages + props.row.prod_image"
                   style="height:40px; width:auto;" />
                </div>
                <div v-else style="padding-left:20px;">-</div>
              </div>
              <div slot="prod_code" slot-scope="props" id="id_cod">
                 <strong>{{ props.row.prod_code }}</strong>
              </div>
              <div slot="prod_desc" slot-scope="props" id="id_desc">
                <div v-if="(props.row.prod_desc != '') && (props.row.prod_desc != null )">
                  <div v-if="props.row.prod_desc.includes('|')">
                    <strong>{{ props.row.prod_desc.split('|')[0] }}</strong>
                  </div>
                  <div v-else>
                    <strong>{{ props.row.prod_desc }}</strong>
                  </div>
                </div>
              </div>
              <div slot="prod_quantity" slot-scope="props" id="id_quantity">
                <strong>{{ props.row.prod_quantity }}</strong>
              </div>
              <div slot="prod_dsdownload" slot-scope="props" id="id_dsdownload">
                <div v-if="(props.row.prod_dsdownload != '') && (props.row.prod_dsdownload != null)">
                  <div v-if="props.row.prod_dsdownload.includes('|')">
                    <a :href="pathDevicePdf + props.row.prod_dsdownload.split('|')[0]" target="_blank">
                        <span class="mr-1"><i class="fa fa-file" style="color:#009DE0"></i></span>
                        {{ props.row.prod_dsdownload.split('|')[0] }}
                    </a>
                  </div>
                  <div v-else>
                    <a :href="pathDevicePdf + props.row.prod_dsdownload" target="_blank">
                        <span class="mr-1"><i class="fa fa-file" style="color:#009DE0"></i></span>
                        {{ props.row.prod_dsdownload }}
                    </a>
                  </div>
                </div>
                <div v-else>{{ $t("bom.not_avaible") }}</div>
              </div>
              <div slot="note" slot-scope="props" id="id_note">-</div>
            </v-client-table>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import NavBarMain from "@/components/NavBarMain";
import BannerPro from "@/components/BannerPro";
import BannerProExpired from "@/components/BannerProExpired";
import NavBarBom from '@/components/NavBarBom';
import { ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

//import for pdf conversion
import jsPDF from "jspdf";
import "jspdf-autotable";
import { mapState } from "vuex";
import ErrorBanner from "@/components/ErrorBanner"

export default {
  name: "BomImpiantoBle",

  components: {
    NavBarMain,
    BannerPro,
    BannerProExpired,
    ClientTable,
    Event,
    jsPDF,
    NavBarBom,
    ErrorBanner
  },

  props: ["plantId"],

  data() {
    return {
      globalReports: null,
      columnsBom: [
        "prod_image",
        "prod_code",
        "prod_desc",
        "prod_type", //lampada emergenza/lampada illuminazione/modulo (centrale, gateway, ak, lssa, sw_11kw, charger, sensori)
        "prod_quantity",
        "prod_dsdownload",
        "prod_note"
      ],
      optionsBom: {
        uniqueKey: "prodcode",
        headings: {
          prod_image: this.$t("bom.prod_img"),
          prod_code: this.$t("bom.prod_code"),
          prod_desc: this.$t("bom.prod_desc"),
          prod_type: this.$t("bom.prod_type"),
          prod_quantity: this.$t("bom.prod_quantity"),
          prod_dsdownload: this.$t("bom.prod_datasheet"),
          prod_note: this.$t("bom.prod_note")
        },
        perPage: 10,
        perPageValues: [10, 20, 50],
        texts: {
          limit: this.$t("report_table.record_per_page"),
          count: "{count} report"
        },
        sortable: ['prod_code', 'prod_quantity', 'prod_type'],
        pagination: { dropdown: false, chunk: 5, edge: true },
        filterByColumn: true,
        filterable: ["prod_code", "prod_desc", "prod_type"],
      },
      theme: "bootstrap4",
      pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES, //pathDeviceImages for ALL : "https://d4rkoyq5pdxjm.cloudfront.net/",
      pathDevicePdf: process.env.VUE_APP_PATH_DEVICE_PDF, //pathDevicePdf for ALL : "https://dirc21u84jv6t.cloudfront.net/",
      //logo BEGHELLI in formato base64, usato se non dovesse esistere quello dell'impianto
      imgData: 'data:image/jpeg;base64,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',
      filtriAttivi: false
    };
  },

  computed: {
    ...mapState(["loading", "error"]),

    //----------------------------------------------------
    //contiene i dati dell'impianto --> viene caricato dallo store quando si connette al Backend tramite SOCKET_ONOPEN
    //----------------------------------------------------
    plantDetails() {
      return this.$store.state.currentPlant || [];
    },
    //----------------------------------------------------
    //contiene l'elenco di tutte le zone dell'impianto, con tutti i rispettivi dati
    //----------------------------------------------------
    zonesDetails() {
      return this.$store.state.plantZones || [];
    },
    //----------------------------------------------------
    //contiene l'elenco di tutti i gateway dell'impianto, con tutti i rispettivi dati
    //----------------------------------------------------
    gatewaysDetails() {
      return this.$store.state.plantUnits || [];
    },
    //----------------------------------------------------
    //restituisce la Bom dell'impianto: un array di oggetti -> [{product_img,product_order_code,product_desc,quantity, product_pdf, note},{...}]
    //----------------------------------------------------
    tableBomComputed() {
        var tableDepo = [];
        // console.log("tableBomComputed-> gatewaysDetails: ", this.gatewaysDetails);
        // console.log("tableBomComputed-> zonesDetails: ", this.zonesDetails);
        //prima i Gateways se esistono
        if (this.gatewaysDetails.length > 0) {
          this.gatewaysDetails.forEach( (cent) => {
            console.log("tableBomComputed central: ", cent.cu_id);
            if (!this.centPresente(cent, tableDepo)) {
              //console.log("Centrale_" + cent.cu_type + " : ", cent.cu_id);
              tableDepo.push({
                prod_image: cent.cu_product_image,
                prod_code: cent.cu_order_code,
                prod_desc: cent.cu_product_desc,
                prod_type: this.$t("bom.gateway"),
                prod_quantity: 1,
                prod_dsdownload: cent.cu_product_pdf,
                prod_note: ""
              });
            } //altrimenti 'centPresente' ha già provveduto ad aumentare la quantity di uno
          });
        }
        //poi le lampade se esistono
        if (this.zonesDetails.length > 0) {
          this.zonesDetails.forEach( (zone) => {
            if (zone.bleLamps.length > 0) {
              zone.bleLamps.forEach( (blelamp) => {
                if (!this.dispPresente(blelamp.lamp, tableDepo, zone)) {
                  //se la lampada non è ancora presente nella LISTA, allora aggiungo un nuovo oggetto all'array
                  //nel caso non ci sia il product_desc, mettiamo la stringa 'unknown' (order_code non si può modificare perché usato il dispPresente)
                  //per distinguere tra lampada di emergenza e di illuminazione devo guardare se 'autonomy' ha un valore (1H,2H,ecc) o meno ('??')
                  let p_desc, p_type;
                  if ((blelamp.lamp.product_desc == null) || (blelamp.lamp.product_desc == "")) {
                    p_desc = this.$t("bom.unknown");
                  } else {
                    p_desc = blelamp.lamp.product_desc
                  }
                  if ((blelamp.lamp.autonomy != null) && (blelamp.lamp.autonomy != '??')) {
                    p_type = this.$t("bom.emergency");
                  } else {
                    p_type = this.$t("bom.lighting")
                  }
                  tableDepo.push({
                    prod_image: blelamp.lamp.product_image,
                    prod_code: blelamp.lamp.order_code,
                    prod_desc: p_desc,
                    prod_type: p_type,
                    prod_quantity: 1,
                    prod_dsdownload: blelamp.lamp.product_pdf,
                    prod_note: ""
                  });
                }
              });
            }
          })
        }
        return tableDepo;
    },
  },

  mounted() {
    if (this.plantDetails.length == 0) {
      this.$store.dispatch('loadPlantDetails', this.plantId);
    }
    // Load fonts when the component is mounted
		this.loadFonts();
  },

  watch: {
    loading(val) {
      if (val == false && this.error == null && (this.plantDetails.length == 0)) {
        console.log("BomImpiantoBle loading --> loadPlantDetails");
        this.$store.dispatch("loadPlantDetails", this.plantId);
      }
      if (val == false && this.error == null && (this.plantDetails.length != 0) && (this.zonesDetails.length == 0)) {
        console.log("BomImpiantoBle loading --> loadPlantZone");
        this.$store.dispatch('loadPlantZones', this.plantId);
      }
      // if (val == false && this.error == null && (this.plantDetails.length != 0) && (this.zonesDetails.length != 0) && (this.gatewaysDetails.length == 0)) {
      //   console.log("BomImpiantoBle loading --> loadUnitsDetails");
      //   this.$store.dispatch('loadUnitsDetails', this.plantId);
      // }
    },

  },

  methods: {
    //Loads all required fonts and stores them in component data.
		async loadFonts() {
			try {
				// Assumes fonts are in your 'public' folder
				this.robotoRegular = await this.loadFontAsBase64('/fonts/Roboto-Regular.ttf');
				this.robotoBold = await this.loadFontAsBase64('/fonts/Roboto-Bold.ttf');
				//console.log('Fonts loaded successfully.');
			} catch (error) {
				console.error('Failed to load fonts:', error);
			}
		},
		// Helper function to load a font from a URL and convert it to Base64
		async loadFontAsBase64(url) {
			const response = await fetch(url);
			// console.log("fetch font: ", response);
			const blob = await response.blob();
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onloadend = () => {
					// Get the Base64 string, but strip the "data:..." prefix
					const base64data = reader.result.split(',')[1];
					resolve(base64data);
				};
				reader.onerror = reject;
				reader.readAsDataURL(blob);
			});
		},
    //----------------------------------------------------
    //restituisce true se il disp è presente nell'array e ne incrementa la quantità
    //----------------------------------------------------
    dispPresente(disp, arr) {
      var trovato = false;
      //'some' conclude l'iterazione appena trova l'elemento (trovato==true)
      arr.some(obj => {
        if (obj.prod_code === disp.order_code) {
          console.log("dispPresente: ", disp.order_code, disp.cu_id);
          trovato = true;
          obj.prod_quantity++;
        }
        return trovato;
      });
      return trovato;
    },

    //----------------------------------------------------
    // Restituisce true se la Cent è presente nell'array e ne incrementa la quantità
    // questa funzione si è resa necessaria perché le Centrali SICURO
    // non hanno l'order_code, e le Centrali LOGICA hanno cu_order_code
    //----------------------------------------------------
    centPresente(cent, arr) {
      var trovato = false;
      //'some' conclude l'iterazione appena trova l'elemento (trovato==true)
      arr.some(obj => {
        if (obj.prod_code === cent.cu_order_code) {
          trovato = true;
          obj.prod_quantity++;
        }
        return trovato;
      });
      return trovato;
    },

    //----------------------------------------------------
    //crea un documento pdf con la Bom dell'imppianto
    //----------------------------------------------------
    async createPDF_Bom()
    {
      var risp = true;
      //nel caso siano attivi dei filtri che riducono la BOM, avviso con un modal
      if (this.$refs.table.count < this.tableBomComputed.length) {
        risp = await this.$bvModal.msgBoxConfirm(this.$t("bom.msgfiltriattivi"), {
          title: this.$t("bom.titlefiltriattivi"),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          cancelVariant: 'dark',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true,
        });
      }
      if (risp == true) {
        console.log("createPDF_Bom-> plantDetails: ", this.plantDetails);
        //Set heading for Bom pdf table
        var columnsBomPdf = [
            {title: this.$t('bom.prod_code'), dataKey: "prod_code"},
            {title: this.$t('bom.prod_desc'), dataKey: "prod_desc"},
            {title: this.$t('bom.prod_type'), dataKey: "prod_type"},
            {title: this.$t('bom.prod_quantity'), dataKey: "prod_quantity"},
            {title: this.$t('bom.prod_note'), dataKey: "prod_note"}
          ];

        //var rowsBom = this.tableBomComputed;

        //recupero i dati attualmente mostrati nella tabella (ref="table") dopo il filtraggio e l'ordinamento
        var rowsBom = this.$refs.table.allFilteredData

        //Define table name -> nome del file
        let plant_header = this.plantDetails.plantname.replaceAll(".","");
        let table_name = this.$t("bom.name_pdf") + plant_header;

        // Only pt supported (not mm or in)
        //var doc = new jsPDF('p', 'pt');
        const doc = new jsPDF({
          orientation: 'p',
          unit: 'pt',
          format: 'a4',
          putOnlyUsedFonts: true,
          floatPrecision: 16
        });

        doc.addFileToVFS('Roboto-Regular.ttf', this.robotoRegular);
        doc.addFileToVFS('Roboto-Bold.ttf', this.robotoBold);
      // Use 'Identity-H' encoding for the font registration to enable Unicode support
        doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal', 'Identity-H');
        doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold', 'Identity-H');

        doc.setFont('Roboto', 'bold');

        // doc.setFont('Helvetica')
        // doc.setFontType("bold");
        doc.setFontSize(12);

        var date_now = new Date();

        //Inserimento del logo come intestazione al PDF
        if (this.plantDetails.logoId != null) {
            console.log("Esiste il logo!");
            let logoUrl = process.env.VUE_APP_API_REST_URL + "?action=getResource&type=logo&id="+this.plantDetails.id+"&rnd=" + Math.random();
            var logoImg = new Image();
            logoImg.src = logoUrl;
            var logoData = await this.getImageData(logoImg);
            var w = 60 * logoImg.width / logoImg.height;
            doc.addImage(logoData, 'PNG', 38, 15, w, 60);
        } else {
            doc.addImage(this.imgData, 'PNG', 38, 15, 70, 20);
        }

        //Inserimento dati impianto in pdf
        doc.text(this.$t('report_pdf.title_impianto') + " : " +  this.plantDetails.plantname,38,95);

        // doc.setFont('Helvetica');
        // doc.setFontType("normal");
        doc.setFont('Roboto', 'normal');
        doc.setFontSize(10);
        doc.text(this.plantDetails.address.street + " " + this.plantDetails.address.housenumber,38,110);
        doc.text(this.plantDetails.address.cap + " - " + this.plantDetails.address.city + " (" + this.plantDetails.address.prov +") " + this.plantDetails.address.country,38,125);

        //doc.setFontType("bold");
        doc.setFont('Roboto', 'bold');
        doc.setFontSize(14);
        doc.text(this.$t('bom.title_pdf').toUpperCase(),38,200);

        //doc.setFontType("normal");
        doc.setFont('Roboto', 'normal');
        doc.setFontSize(11);
        doc.text(date_now.toLocaleDateString() + " - " + date_now.toLocaleTimeString(), 38, 220);

        doc.setFontSize(8);

        // //Table report plant
        doc.autoTable({
          columns: columnsBomPdf,
          body: rowsBom,
          headStyles : {
            font: "Roboto",
						fontSize: 11,
            fillColor : [59, 156, 204]
          },
          styles: {
            font: "Roboto",
            fontSize: 10
          },
          alternateRowStyles: {fillColor : [225, 238, 245]},
          tableLineColor: [59, 156, 204],
          tableLineWidth: 0.1,
          startY: 250,
          // Hook used for customizing texts or styles of specific cells after they have been formatted by this plugin.
          // A noi serve per intercettare le stringhe dei multi-prodotto, e creare un array con i singoli prodotti
          // per una corretta visualizzazione
          didParseCell: function(data) {
            if (data.row.section === 'body' && (data.column.dataKey === 'prod_desc')) {
              if ((data.cell.raw != null) && (data.cell.raw.includes('|'))) {
                //data.cell.styles.fontSize = 8;
                data.cell.raw = data.cell.raw.split('|')[0];
                data.cell.text = "";
                data.cell.text = data.cell.raw;
              }
            }
          },
        });

        doc.addImage(this.imgData, 'PNG', (doc.internal.pageSize.width/2), doc.internal.pageSize.height - 40, 70, 20);
        doc.save(table_name);
      }
    },

    //----------------------------------------------------
    //esegue una invocazione HTTP GET verso AWS Gateway per recuperare un'immagine
    //----------------------------------------------------
    async getImageData(logo) {
      logo.crossOrigin="anonymous";
      await logo.decode();
      console.log("immagine:" + logo.width + "x" + logo.height ,logo);
      var canvas = document.createElement("canvas");
      canvas.width = logo.width;
      canvas.height = logo.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(logo, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      console.log("logo dataurl:" + dataURL);
      return dataURL;
    },

  }
};
</script>

<style lang="scss">

.text-widget {
  font-family: "Roboto Condensed", sans-serif;
  font-size: 15px;
}

.card-header {
  background-color: #ffffff;
}
</style>
